<template>
  <div class="nav bg-image" >
    <div class="nav-title">
      {{title}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: '',
      type: String
    }
  }
}
</script>

<style lang="less" scoped>
.nav{
  width: 100%;
  height: 145px;
  overflow: hidden;
  position: relative;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}
.nav-title {
  //width: 100%;
  height: 70px;
  line-height: 70px;
  text-align: center;
  position: relative;
  bottom: 0;
  left: 0;
  z-index: 10;
  font-family: 'PingFang-SC-Medium';
  font-size: 34px;
  letter-spacing: 2px;
  width: 100%;
}
.bg-image {
  // background-image: url('https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/huixiaopiao-miniprogram/order-header-bg.png');
  background-color: #fff;
  background-size: cover;
  height: 70px;
  padding-bottom: 115px;
  color:  #333;
}
</style>
